/** @internal */
export enum RequestMethod {
    GET = 'GET',
    POST = 'POST',
}

/** @internal */
export type RequestOptions = {
    parameters?: { [key: string]: string }
    jitterMillis?: number
    /**
     * Per-attempt abort deadline in milliseconds. When set, each network attempt is aborted if it
     * does not settle within this duration. When omitted, attempts are not time-bounded (v3 behavior).
     */
    timeoutMillis?: number
    /**
     * Maximum number of network attempts, counting the first, before the request gives up
     * retrying. Defaults to `Globals._eventMaxSendAttempts`. Set to 1 for a request that must be
     * attempted exactly once.
     *
     * Which outcomes are retried, and how long each wait is, are fixed by `request/backoff.ts`.
     */
    maxAttempts?: number
    /**
     * Cache mode for the underlying `fetch`. Omitted means the browser default, which
     * consults the HTTP cache - the desired behaviour for anything cacheable.
     *
     * Set `'reload'` to require a network round trip. Needed where a stored or cached copy
     * is exactly what the caller is trying to escape: the CDN serves domain settings with a
     * long `max-age`, so bypassing the SDK's own storage is not on its own enough to
     * observe a change.
     */
    cacheMode?: RequestCache
}

/** @internal */
export type RequestResults<T> = {
    data?: T
    response: Response
}
